import { Component } from '@angular/core';

@Component({
  selector: 'app-sblock-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class SblockFaqComponent {
  title = 'Preguntas frecuentes';
  subtitle = 'Resolvemos las dudas mas comunes sobre nuestra plataforma de formacion.';
  backgroundColor = '#f8f9fa';
  titlesColor = '#2c2c54';
  secondaryColor = '#555';

  faqs: Array<{ title: string; content: string; collapsed: boolean }> = [
    {
      title: 'Como puedo inscribirme en un curso?',
      content:
        'Solo necesitas crear una cuenta gratuita, elegir el curso que te interese ' +
        'y pulsar en inscribirte. Tendras acceso inmediato a todo el contenido.',
      collapsed: false
    },
    {
      title: 'Los cursos tienen un horario fijo?',
      content:
        'No. Todos nuestros cursos son a tu ritmo. Puedes acceder al contenido ' +
        'cuando quieras y desde cualquier dispositivo.',
      collapsed: false
    },
    {
      title: 'Recibire un certificado al finalizar?',
      content:
        'Si, al completar cada curso recibiras un certificado de finalizacion ' +
        'que podras descargar desde tu perfil.',
      collapsed: false
    },
    {
      title: 'Puedo acceder al contenido desde el movil?',
      content:
        'Por supuesto. La plataforma es totalmente responsive y se adapta a ' +
        'telefonos, tabletas y ordenadores.',
      collapsed: false
    }
  ];

  language = 'es';

  btn1Active = false;
  btn1Text = 'Contactar con nosotros';
  btn1Link = '#';

  btn2Active = false;
  btn2Text = 'Ver mas';
  btn2Link = '#';
  linkColor = '#6c5ce7';

  toggleCollapse(faq: { collapsed: boolean }): void {
    const wasOpen = faq.collapsed;
    this.faqs.forEach(f => (f.collapsed = false));
    faq.collapsed = !wasOpen;
  }
}
